export interface IUser {
  _id?: string;
  email: string;
  createdAt?: Date;
  profileImageId?: string;
  role: ERole;
  gender: EGender;
  firstname: string;
  lastname: string;
  conversations?: string[]; // array of conversation ids
  description?: string;
  artistName?: string;
  subscription?: ISubscription;
  phone?: string;
  address?: IAddress;
  gtcAccepted?: boolean;
  seenChat?: Date;
  stripeCustomerId?: string;
}

export interface IAddress {
  street: string;
  postcode: string;
  city: string;
  country: string;
}

export interface ISubscriptionCategory {
  _id?: string;
  name: string;
  priceIds: string[];
  price: string;
  description: string;
  limit: number;
}

export interface ISubscription {
  _id?: string;
  subscriptionId: string;
  category: ISubscriptionCategory;
  status: ESubscriptionStatus;
  productName: string;
  productId: string;
  priceId: string;
  trialEnd: number;
  trialStart: number;
  currentPeriodEnd: number;
  currentPeriodStart: number;
  start: number;
  end: number;
  createdAt: number;
  updatedAt: number;
}

export enum ESubscriptionStatus {
  ACTIVE = 'active',
  PAUSED = 'paused',
  TRIALING = 'trialing',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
  CANCELED = 'canceled',
}

export enum ERole {
  USER = 'user',
  ADMIN = 'admin',
  ARTIST = 'artist',
}
export enum EGender {
  MALE = 'male',
  FEMALE = 'female',
  DIVERS = 'divers',
  UNKNOWN = 'unknown',
}
